module.exports = __webpack_public_path__ + "img/UserAppSettings.ba93a1b4.svg";